import dayjs from 'dayjs'
import React, { useState } from 'react'
import { useFormContext } from 'react-hook-form'
import { FormFields } from '~/components/FormFields'
import { useDebounce } from 'use-lodash-debounce';
import { NewsletterQuery } from '~/QueryHooks/NewsLetterQuery';

interface Props {
  label: string
  name: string,
  type: string
}

const AmountFilter: React.FC<Props> = (props) => {
  const { control } = useFormContext()
  const { label, name, type } = props

  const [searchQuery, setSearchQuery] = useState('')
  const debouncedSearchQuery = useDebounce(searchQuery, 300)

  const {
    data: tradingSlotsOptions,
    isFetching: isFetching,
    isLoading: isLoading
  } = NewsletterQuery.getTradingSlotsOptions(type, { search: debouncedSearchQuery });

  function handleSearchChange(event: React.SyntheticEvent<HTMLElement>, data: { searchQuery: string }) {
    setSearchQuery(data.searchQuery)
  }

  return <FormFields.Select
    control={control}
    name={name}
    label={label}
    placeholder={label}
    clearable
    options={tradingSlotsOptions?.map(tradingSlot => ({
      value: tradingSlot.id,
      text: `${dayjs(tradingSlot.dateFrom).format('DD.MM.YYYY')} (${tradingSlot.uniqueId})`
    })) || []}
    selection
    selectOnBlur={false}
    multiple
    loading={isFetching || isLoading}
    onSearchChange={handleSearchChange}
    search={(options, query) => {
      return options;
    }}
  />
}
export default AmountFilter